export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Merchant',
    },
    cell: {
      type: 'slot',
      name: 'merchant',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Deal type',
    },
    cell: {
      type: 'slot',
      name: 'direction',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Orders amount',
    },
    cell: {
      type: 'slot',
      name: 'ordersCount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades count',
    },
    cell: {
      type: 'slot',
      name: 'tradesCount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Completed trades count',
    },
    cell: {
      type: 'slot',
      name: 'completedTradesCount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Orders count',
    },
    cell: {
      type: 'slot',
      name: 'ordersAmount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades amount',
    },
    cell: {
      type: 'slot',
      name: 'tradesAmount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Completed trades amount',
    },
    cell: {
      type: 'slot',
      name: 'completedTradesAmount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades conversion',
    },
    cell: {
      type: 'slot',
      name: 'tradesConversion',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Amount conversion',
    },
    cell: {
      type: 'slot',
      name: 'amountConversion',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Orders in the last 5 minutes',
    },
    cell: {
      type: 'slot',
      name: 'ordersCountInFiveMinutes',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades in the last 5 minutes',
    },
    cell: {
      type: 'slot',
      name: 'tradesCountInFiveMinutes',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trades conversion in the last 5 minutes',
    },
    cell: {
      type: 'slot',
      name: 'tradesConversionInFiveMinutes',
    },
  },
];
